import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import classNames from 'classnames';
import _ from 'lodash';
import Moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import 'react-widgets/lib/less/react-widgets.less';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import DatePicker from '../Common/datePicker';
import InputField from '../Common/inputField';
import { Grid, Row, Col, Panel, Button, Table, Input, Textarea } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'

momentLocalizer(Moment);



class InventoryRepackageForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            orderNum: 0,

            inventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            targetInventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            repackagedInventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        const { currentInventoryRepackage } = this.props;
        if(currentInventoryRepackage) {
          this.props.fetchInventoryRepackageDetail(currentInventoryRepackage.WarehouseRepackage_id)
            .then(() => {
              this.props.fetchInventories();
            });
        }
        else
          this.props.fetchInventories();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventories are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if(nextProps.currentInventoryRepackageDetail && nextProps.currentInventoryRepackageDetail != this.props.currentInventoryRepackageDetail) {
          let orderNum = 0;
          let warehouse_Repackage_Line = nextProps.currentInventoryRepackageDetail.Warehouse_Repackage_Line;
          warehouse_Repackage_Line.map(repackage => {
            orderNum = Math.max(orderNum, repackage.Pairid);
          });
          orderNum = orderNum+1;
          const repackagedInventories = {...this.state.repackagedInventories, rows: nextProps.currentInventoryRepackageDetail.Warehouse_Repackage_Line };
          this.setState({ repackagedInventories, orderNum: orderNum });
        }
        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            const inventories = {...this.state.inventories, rows: nextProps.inventories }
            const targetInventories = {...this.state.targetInventories, rows: nextProps.inventories }
            this.setState({
                inventories,
                targetInventories
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    setInventoryToRepackage(e) {
        e.preventDefault();
        const { inventories, targetInventories, repackagedInventories, orderNum } = this.state;
        const inventoryToLocate = { ...inventories.selectedRows[0],
            Pairid: orderNum,
            // Zone: "Hello",
            // Bin: "Hi",
            Quantity: "-" + this.props.quantityValue
        };

        const inventoryRepackaged = { ...targetInventories.selectedRows[0],
            Pairid: orderNum,
            // Zone: this.props.toZoneValue,
            // Bin: this.props.toBinValue,
            Quantity: "+" + this.props.repackagedQuantityValue
        }


        let newRepackagedInventoriesRows = [ ...repackagedInventories.rows ];
        let newInventoriesRows = [ ...inventories.rows ];
        let newTargetInventoriesRows = [ ...targetInventories.rows ];

        newRepackagedInventoriesRows.push(inventoryToLocate, inventoryRepackaged);

        // const index = _.findIndex(newInventoriesRows, { 'Vendor_id': inventories.selectedRows[0].Vendor_id });
        // if (index > -1) {
        //     newInventoriesRows.splice(index, 1);
        // }
        //
        // const targetIndex = _.findIndex(newTargetInventoriesRows, { 'Vendor_id': targetInventories.selectedRows[0].Vendor_id });
        // if (targetIndex > -1) {
        //     newTargetInventoriesRows.splice(targetIndex, 1);
        // }

        let newRepackagedInventories = { ...repackagedInventories, rows: newRepackagedInventoriesRows };
        let newInventories = { ...inventories, rows: newInventoriesRows };
        let newTargetInventories = { ...targetInventories, rows: newTargetInventoriesRows };

        // newInventories.selectedRows = [];
        // newTargetInventories.selectedRows = [];

        this.setState({
            repackagedInventories: newRepackagedInventories,
            inventories: newInventories,
            targetInventories: newTargetInventories,
            orderNum: orderNum + 1
        })
    }

    cancelInventoryRepackage(e) {
        e.preventDefault();
        const { inventories, targetInventories, repackagedInventories } = this.state;
        const OrderID = repackagedInventories.selectedRows[0].Pairid;

        let newRepackagedInventoriesRows = [ ...repackagedInventories.rows ];
        // let newInventoriesRows = [ ...inventories.rows ];
        // let newTargetInventoriesRows = [ ...targetInventories.rows ];

        let index = _.findIndex(newRepackagedInventoriesRows, { 'Pairid': OrderID });
        if (index > -1 && parseInt(newRepackagedInventoriesRows[index].Quantity) > 0 ) {
            // newTargetInventoriesRows.push({...newRepackagedInventoriesRows[index]})
            newRepackagedInventoriesRows.splice(index, 1);
            index = _.findIndex(newRepackagedInventoriesRows, { 'Pairid': OrderID });
            // newInventoriesRows.push({...newRepackagedInventoriesRows[index]})
            newRepackagedInventoriesRows.splice(index, 1);
        } else if (index > -1) {
            // newInventoriesRows.push({...newRepackagedInventoriesRows[index]})
            newRepackagedInventoriesRows.splice(index, 1);
            index = _.findIndex(newRepackagedInventoriesRows, { 'Pairid': OrderID });
            // newTargetInventoriesRows.push({...newRepackagedInventoriesRows[index]})
            newRepackagedInventoriesRows.splice(index, 1);
        }

        let newRepackagedInventories = { ...repackagedInventories, rows: newRepackagedInventoriesRows };
        // let newInventories = { ...inventories, rows: newInventoriesRows };
        // let newTargetInventories = { ...targetInventories, rows: newTargetInventoriesRows };

        newRepackagedInventories.selectedRows = [];

        this.setState({
            repackagedInventories: newRepackagedInventories
        })
    }


    createRepackage(e) {
      e.preventDefault();
      if(this.props.currentInventoryRepackageDetail) {
        if(!this.checkPermission("change_warehouse_repackage"))
          this.props.editInventoryRepackage(this.props.currentInventoryRepackageDetail.WarehouseRepackage_id, 1, this.props.postingDate, this.props.note, Data.Selectors.getRows(this.state.repackagedInventories));
        else
          alert("You have no permission!");
      }
      else
        this.props.createInventoryRepackage(1, this.props.postingDate, this.props.note, Data.Selectors.getRows(this.state.repackagedInventories));
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.inventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var inventories = {...this.state.inventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ inventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.inventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const inventories = {...this.state.inventories, filters: newFilters }
                this.setState({ inventories });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const inventories = {...this.state.inventories, selectedRows: rows }
                this.setState({ inventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true
                },
                {
                    key: 'Batch_PONum',
                    name: <Translate value="batch_num" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryRepackageForm-dataGrid1">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTargetTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.targetInventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var targetInventories = {...this.state.targetInventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ targetInventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.targetInventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const targetInventories = {...this.state.targetInventories, filters: newFilters }
                this.setState({ targetInventories });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const targetInventories = {...this.state.targetInventories, selectedRows: rows }
                this.setState({ targetInventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true
                },
                {
                    key: 'Batch_PONum',
                    name: <Translate value="batch_num" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryRepackageForm-dataGrid2">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderRepackagedTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.repackagedInventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var repackagedInventories = {...this.state.repackagedInventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ repackagedInventories: repackagedInventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.repackagedInventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const repackagedInventories = {...this.state.repackagedInventories, filters: newFilters }
                this.setState({ repackagedInventories: repackagedInventories });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let { repackagedInventories } = this.state
                let rows = repackagedInventories.rows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                }
                const newRepackagedInventories = {...repackagedInventories, rows: rows }
                this.setState({
                    repackagedInventories: newRepackagedInventories
                });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let { repackagedInventories } = this.state
                let rows = getRows();//repackagedInventories.rows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                const newRepackagedInventories = {...repackagedInventories, rows: rows }
                this.setState({
                    repackagedInventories: newRepackagedInventories,
                });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const repackagedInventories = {...this.state.repackagedInventories, selectedRows: rows };
                this.setState({ repackagedInventories: repackagedInventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                },
                {
                    key: 'Quantity',
                    name: <Translate value="convert_quantity" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                    editable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryRepackageForm-dataGrid3">
                    <ReactDataGrid
                        rowKey='Pairid'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onCellsDragged={handleCellDrag}
                        enableCellSelect={true}
                        onRowUpdated={handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const inventoryRepackageWarehouseLocation = (<Translate value="inventory_repackage_warehouse_loc" />);
        const productRepackage = (<Translate value="product_repackage_sheet_product_repackage" />);
        const generalProductRepackage = (<Translate value="general_product_repackage" />);
        const { inventories, targetInventories, repackagedInventories } = this.state;
        const { invalid } = this.props;
        return (
            <ContentWrapper>
                <div className="content-heading"><Translate value="inventory_repackage" /></div>
                <Row><Col sm={ 12 }>
                    <Link to="/inventories/repackage"  className="btn btn-green buttonStyle" ><em className="fa fa-mail-reply"/></Link>
                    <div className="pull-right">
                      <button
                        className="btn btn-primary buttonStyle"
                        onClick={(e) => this.createRepackage(e) }>
                          <em className="fa fa-save marginRightStyle" /><Translate value="save" /></button>
                    </div>
                </Col></Row>
              <Row className="marginTopStyle">
                    <Col sm={ 7 }>
                        <Panel header={inventoryRepackageWarehouseLocation}>
                            <Row>
                              <h4><Translate value="current_inventory" /></h4>
                              <hr/>
                                <Col sm={ 8 }>
                                    <p><Translate value="msg_select_an_inventory_to_repackage" /></p>
                                    {this.renderTable() }
                                </Col>
                                <Col sm={ 4 }>
                                  <p><Translate value="details_and_repackage" /></p>
                                  <Row>
                                      <Col sm={6}><label><Translate value="product_num" /></label></Col>
                                      <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductNum : <Translate value="please_select_inventory" />}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="product_name" /></label></Col>
                                      <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductName : <Translate value="please_select_inventory" />}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="package_type" /></label></Col>
                                      <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductUnitOfMeasure : <Translate value="please_select_inventory" />}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="batch_num" /> (<Translate value="po_num" />) </label></Col>
                                      <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : <Translate value="please_select_inventory" />}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="current_zone" /></label></Col>
                                      <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ZoneName : <Translate value="please_select_inventory" />}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="current_bin" /></label></Col>
                                      <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].BinName : <Translate value="please_select_inventory" />}</Col>
                                  </Row>
                                  <Row>
                                      <Col sm={6}><label><Translate value="current_quantity" /></label></Col>
                                      <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].BinAmount : <Translate value="please_select_inventory" />}</Col>
                                  </Row>
                                  <Row>
                                    <Col sm={ 6 }><label><Translate value="repackage_quantity" /></label></Col>
                                    <Col sm={ 6 }>
                                        <Field component={InputField} name="Quantity"></Field>
                                    </Col>
                                  </Row>
                                  <Row><Col sm={ 12 }>
                                      {inventories.selectedRows[0] &&
                                          parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) &&
                                          <p className="parsley-error-message"><Translate value="msg_repackage_qty_cannot_exceed_current_qty" /></p>}
                                  </Col></Row>
                                </Col>
                            </Row>
                            <Row>
                              <h4><Translate value="current_target_inventory" /></h4>
                              <hr/>
                              <Col sm={ 8 }>
                                  <p><Translate value="msg_select_an_inventory_as_target" /></p>
                                  {this.renderTargetTable() }
                              </Col>
                              <Col sm={ 4 }>
                                <p><Translate value="details_&_repackage" /></p>
                                <Row>
                                    <Col sm={6}><label><Translate value="product_num" /></label></Col>
                                    <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductNum : "Please select an inventory"}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><label><Translate value="product_name" /></label></Col>
                                    <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductName : "Please select an inventory"}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><label><Translate value="package_type" /></label></Col>
                                    <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ProductUnitOfMeasure : "Please select an inventory"}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><label><Translate value="batch_num" />(<Translate value="po_num" />) </label></Col>
                                    <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].Batch_PONum : "Please select an inventory"}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><label><Translate value="current_zone" /></label></Col>
                                    <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].ZoneName : "Please select an inventory"}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><label><Translate value="current_bin" /></label></Col>
                                    <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].BinName : "Please select an inventory"}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><label><Translate value="current_quantity" /></label></Col>
                                    <Col sm={6}>{targetInventories.selectedRows[0] ? targetInventories.selectedRows[0].BinAmount : "Please select an inventory"}</Col>
                                </Row>
                                <Row>
                                  <Col sm={ 6 }><label><Translate value="repackage_target_quantity" /></label></Col>
                                  <Col sm={ 6 }>
                                      <Field component={InputField} name="RepackagedQuantity"></Field>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm={ 6 }><label><Translate value="target_weight" /></label></Col>
                                  <Col sm={ 6 }>
                                      <Field component={InputField} name="Weight"></Field>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row><Col sm={ 12 }>
                                <button
                                    className="btn btn-primary pull-right"
                                    onClick={(e) => this.setInventoryToRepackage(e) }
                                    disabled={ !inventories.selectedRows[0] || !targetInventories.selectedRows[0] || invalid
                                        || parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus)
                                    }><Translate value="submit" /></button>
                            </Col></Row>
                        </Panel>
                      </Col>
                      <Col sm={ 5 }>
                        <Panel header={productRepackage}>
                            <h4><Translate value="inventory_repackage_sheet" /></h4>
                            <hr/>
                            <p><Translate value="list_of_inventory_repackage_lines" /></p>
                            {this.renderRepackagedTable() }
                            <Row><Col sm={ 12 }>
                                <button
                                    className="btn btn-warning pull-right marginTopStyle"
                                    onClick={(e) => this.cancelInventoryRepackage(e) }
                                    disabled={ !repackagedInventories.selectedRows[0]}><Translate value="cancel" /></button>
                            </Col></Row>
                        </Panel>
                        <Panel header={generalProductRepackage}>
                          <h4><Translate value="general" /></h4>
                            <hr/>
                            <Row>
                                <Col sm={ 7 }>
                                    <Col sm={ 6 }><Translate value="repackage_date" />: </Col>
                                    <Col sm={ 6 } className="marginBottomStyle">
                                        <Field component={DatePicker} name="PostingDate"></Field>
                                    </Col>
                                    <Col sm={ 6 }><Translate value="repackage_user" />: </Col>
                                    <Col sm={ 6 }>
                                        <Field component={InputField} name="Modify_Username"></Field>
                                    </Col>
                                    <Col sm={ 3 }><Translate value="note" />: </Col>
                                    <Col sm={ 9 }>
                                        <Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '100px' }}/>
                                    </Col>
                                </Col>
                            </Row>
                        </Panel>
                    </Col>
                </Row>
                <br/>
            </ContentWrapper >
        );
    }
}



export default InventoryRepackageForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryRepackageForm.jsx